import { Level } from '../../types/level';
import { LevelDifficultyPoint } from '../../types/levelDifficultyPoint';

const coerceInt = (v: unknown): number =>
  typeof v === 'number' && !Number.isNaN(v) ? Math.trunc(v) : 0;

export const normalizeDifficultyPoints = (
  items: LevelDifficultyPoint[] | unknown[] | null | undefined
): LevelDifficultyPoint[] => {
  if (!items || items.length === 0) {
    return [];
  }

  return items.map((raw) => {
    const row = raw as Record<string, unknown>;
    const numberVal = coerceInt(row.number ?? row.Number);
    const difficultyVal = coerceInt(row.difficulty ?? row.Difficulty);
    return { number: numberVal, difficulty: difficultyVal };
  });
};

export const normalizeApiLevel = (level: Level): Level => {
  const row = level as unknown as Record<string, unknown>;
  return {
    ...level,
    number: coerceInt(row.number ?? row.Number),
    difficulty: coerceInt(row.difficulty ?? row.Difficulty),
  };
};

export const normalizeApiLevels = (levels: Level[]): Level[] =>
  (levels ?? []).map((lvl) => normalizeApiLevel(lvl));
